<template>
    <v-ons-page id="app">

        <v-ons-navigator swipeable
                         :page-stack="pageStack"
                         :options="{animation: 'slide'}"

                         @pop="pageStack.pop()"
                         @push="pageStack = [...pageStack, $event]"
                         @replace="pageStack = [...pageStack.slice(0, -1), $event]"
        >
        </v-ons-navigator>
    </v-ons-page>
</template>

<script>
    const log = function (args) {
        console.log(args);
    }
    import lang from './pages/LangPage'
    import {onReady} from './events'

    export default {
        name: 'app',

        data() {
            return {
                pageStack: [lang]
            };
        },
        methods: {
            log
        },
        created() {
            onReady();
            document.addEventListener("online", () => {
                this.$store.commit('connection/toggle', true);

            }, false);
            document.addEventListener("offline", () => {
                this.$store.commit('connection/toggle', false);

            }, false);
        },
    }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/App.vue